// extracted by css-extract-rspack-plugin
export default {"authorLinkContainer":"AuthorLink-module__authorLinkContainer__h8OXS3j","authorNameLink":"AuthorLink-module__authorNameLink__Bjd3dlo"};